module.exports = __webpack_public_path__ + "media/new_images/logo-mark-d8d477c7.svg";